export function formatDate(d: Date) {
    const month = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    const date = new Date(d);
    const minute = date.getMinutes() === 0 ? '00' : date.getMinutes();
    const time = `${date.getHours()}:${minute}`;
    const formatDate = `${date.getDate()}.${month[date.getMonth()]}.${date.getFullYear()}`;
    const fullDateTime = `${formatDate} ${time}`;
    return {date: formatDate, time, fullDateTime};
}

export function addFormatDate(date ?:string) {
    function zeroPad(d:number) {
        return ("0" + d).slice(-2)
    }
    if (!date) return '';
    let parsed = new Date(date);
    let time = [zeroPad(parsed.getHours()), zeroPad(parsed.getMinutes())].join(":");
    let newDate= [zeroPad(parsed.getDate()), zeroPad(parsed.getMonth() + 1), parsed.getFullYear()].join(".");
    return time + " " + newDate;
}



